
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/webhook-settings",
      function () {
        return require("private-next-pages/profile/webhook-settings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/webhook-settings"])
      });
    }
  